import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeesListComponent } from './pages/fees-list/fees-list.component';

// const routes: Routes = [];
const feesroutes: Routes = [
    { path: 'office-fees', component: FeesListComponent },
    // The add / edit dialog on the list (these URLs open it).
    { path: 'office-fees/add', component: FeesListComponent },
    { path: 'office-fees/edit/:feeId', component: FeesListComponent }
];
@NgModule({
    imports: [RouterModule.forChild(feesroutes)],
    exports: [RouterModule]
})
export class FeesRoutingModule { }
